(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mk-global-actions"] && !Shopify.designMode) return;
  try {
    (() => {
    const observers = new WeakMap();
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const bind = (scope) => {
      const root = scope && scope.querySelectorAll ? scope : document;
      const nodes = root.querySelectorAll('[data-mk-reveal]');
      if (!nodes.length) return;
      document.documentElement.classList.add('mk-motion-enabled');
      if (reduced.matches || !('IntersectionObserver' in window)) {
        nodes.forEach((node) => node.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries, instance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          instance.unobserve(entry.target);
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
      nodes.forEach((node) => observer.observe(node));
      if (scope && scope.nodeType === 1) observers.set(scope, observer);
    };
    bind(document);
    document.addEventListener('shopify:section:load', (event) => bind(event.target));
    document.addEventListener('shopify:section:unload', (event) => observers.get(event.target)?.disconnect());
  })();

    (() => {
      if (document.documentElement.dataset.mkNavigationBound === 'true') return;
      document.documentElement.dataset.mkNavigationBound = 'true';
      const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      const getWrapper = () => document.querySelector('.page-wrapper');
      const getHeaderOffset = () => {
        const rootValue = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mk-header-offset')); const bodyValue = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height'));
        if (Number.isFinite(rootValue) && rootValue > 0) return rootValue; if (Number.isFinite(bodyValue) && bodyValue > 0) return bodyValue;
        const group = document.querySelector('#header-group');
        return (group && group.getBoundingClientRect().height) || 123;
      };
      const targetFromHash = () => {
        if (!window.location.hash) return null;
        try {
          return document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
        } catch {
          return null;
        }
      };
      const scrollToHash = () => {
        const wrapper = getWrapper();
        const target = targetFromHash();
        if (!wrapper || !target) return;
        const wrapperRect = wrapper.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const top = wrapper.scrollTop + targetRect.top - wrapperRect.top - getHeaderOffset() + 10;
        wrapper.scrollTo({top: Math.max(0, top), behavior: motionPreference.matches ? 'auto' : 'smooth'});
      };
      const resetPageScroll = () => {
        const wrapper = getWrapper();
        if (!wrapper) return;
        if (targetFromHash()) {
          requestAnimationFrame(() => requestAnimationFrame(scrollToHash));
        } else {
          wrapper.scrollTop = 0;
        }
      };
      window.addEventListener('pageshow', resetPageScroll);
      window.addEventListener('hashchange', scrollToHash);
      document.addEventListener('shopify:section:load', () => requestAnimationFrame(resetPageScroll));
      requestAnimationFrame(resetPageScroll);
    })();

  
    (() => {
      const setMeasuredHeaderOffset = () => {
        const announcement = document.querySelector('.announcement-bar');
        const header = document.querySelector('header');
        const offset = (announcement?.offsetHeight || 0) + (header?.offsetHeight || 0);
        if (offset > 0) { document.documentElement.style.setProperty('--mk-header-offset', offset + 'px'); document.documentElement.style.setProperty('--mk-announcement-height', (announcement?.offsetHeight || 0) + 'px'); }
      };
      setMeasuredHeaderOffset();
      requestAnimationFrame(setMeasuredHeaderOffset);
      window.addEventListener('resize', setMeasuredHeaderOffset, {passive: true});
      document.addEventListener('shopify:section:load', setMeasuredHeaderOffset);
    })();
  } catch(e) { console.error(e); }
})();

})();
